export default "__VITE_ASSET__2c26e23f__"